import React from 'react';
import StyledView from './styled_view';
import {HashLink as Link} from 'react-router-hash-link';

class ViewTable extends StyledView {

	constructor(props) {
		super(props);
		this.state = {
			data:    [],
			alpha:   [],
			hasnext: true,
			loading: false,
			cmp_graph: {
				left: '',
				right: ''
			}
		};
		this.showNext    = this.showNext.bind(this);
		this.clickAlpha  = this.clickAlpha.bind(this);
		this.colsStyle   = this.props.view.col.map((col) => this.createCss(col));
		this.uriColIndex = this.getURIColIndex();
		this.colsField   = this.getColsFieldIndex();
		this.groupCols   = this.props.view.col.map((col) => {
			return {
				is_group:  col.hasOwnProperty('col_group') && col.col_group === 'true',
				separator: col.hasOwnProperty('col_separator') ? col.col_separator.replace(/"/g, '') : ' ',
				lastVal:   null
			}
		});
		this.hasGroup = false;
		for (let i = 0; i < this.groupCols.length; i++) {
			if (this.groupCols[i].is_group) {
				this.hasGroup = true;
				break;
			}
		}
		if (this.props.view.type === 'cmp' && this.props.view.graph_list.length > 1) {
			this.state.cmp_graph.left = this.props.view.graph_list[0];
			this.state.cmp_graph.right = this.props.view.graph_list[1];
		}
	}

	getURIColIndex() {
		const cols = this.props.view.col;
		for (let i = 0; i < cols.length; i++) {
			if (cols[i]['col_uri'] === 'true') {
				return i;
			}
		}
		throw new Error('URI column not specified');
	}

	getColsFieldIndex() {
		const cols =  this.props.view.col;
		let list   = [];
		for (let i = 0; i < cols.length; i++) {
			list[cols[i]['col_field']] = i;
		}
		return list;
	}

	componentDidMount() {
		this.loadData();
	}

	showNext(e) {
		e.preventDefault();
		this.loadData();
	}

	loadData(reload = false) {
		const view   = this.props.view;
		const filter = this.props.filter;
		const data   = this.state.data;
		this.setState({loading: true});
		this.props.model.getData(view.id, reload ? 0 : data.length, filter || this.getAlphaFilter(), this.state.cmp_graph)
			.then(response => {
				this.setState({
					data:    reload ? this.groupConcat(reload, response.data) : this.groupConcat(reload, response.data, data),
					alpha:   this.initAlpha(response.alpha),
					hasnext: response.hasnext,
					loading: false
				});
			});
	}

	getGroupRow(accumulator, new_row) {
		let is_new_row = false;
		for (let j = 0; j < new_row.length; j++) {
			const group_coll = this.groupCols[j];
			const new_cell = new_row[j];
			if (group_coll.is_group && group_coll.lastVal !== new_cell) {
				group_coll.lastVal = new_cell;
				is_new_row = true;
			}
		}
		return [is_new_row, (is_new_row ? [] : accumulator[accumulator.length - 1])];
	}

	groupConcat(reload, new_data, old_data = null) {
		if (reload) {
			this.groupCols.forEach((e) => {e.lastVal = null});
		}
		const data = this.hasGroup ? new_data.reduce((accumulator, new_row) => {
			let [ready_to_add, row] = this.getGroupRow(accumulator, new_row);
			for (let j = 0; j < new_row.length; j++) {
				const new_cell = new_row[j];
				const group_coll = this.groupCols[j];
				if (ready_to_add) {
					if (group_coll.is_group) {
						row.push(new_cell);
					} else {
						let val = {};
						val[new_cell] = 1;
						row.push(val);
					}
				} else {
					if (row[j] instanceof Object) {
						row[j][new_cell] = 1;
					}
				}
			}
			if (ready_to_add) {
				accumulator.push(row);
			}
			return accumulator;
		}, old_data ? old_data : []) : new_data;
		return old_data ? (this.hasGroup ? old_data : old_data.concat(data)) : data;
	}

	initAlpha(alpha) {
		let list = [];
		if (alpha) {
			for (let i = 0; i < alpha.length; i++) {
				list.push({ch: alpha[i], use: this.isAlphaUsed(i)});
			}
		}
		return list;
	}

	isAlphaUsed(index) {
		const alpha = this.state.alpha;
		return alpha.length && alpha[index].use || false;
	}

	getAlphaFilter() {
		const alpha = this.state.alpha;
		let list = [];
		for (let i = 0; i < alpha.length; i++) {
			if (alpha[i].use) {
				list.push(alpha[i].ch);
			}
		}
		return list;
	}

	clickAlpha(index) {
		const alpha = this.state.alpha[index];
		alpha.use = ! alpha.use;
		this.loadData(true);
	}

	clearAlpha() {
		const alpha = this.state.alpha;
		for (let i = 0; i < alpha.length; i++) {
			alpha[i].use = false;
		}
		this.loadData(true);
	}

	createCss(col) {
		const css = super.createCss(col);
		if (col['alignment']) {
			css.textAlign = col['alignment'];
		}
		return css;
	}

	renderDebugInfo() {
		if (document.title === 'Development' ) {
			return (<pre>
				view: '{JSON.stringify(this.props.view, null, 4)}'<br/>
				filter: '{JSON.stringify(this.props.filter, null, 4)}'
			</pre>);
		}
	}

	renderAlpha() {
		const alpha = this.state.alpha;
		if (alpha.length) {
			return (<ul className='alpha'>
					<li
						className = 'clear-alpha'
						title     = 'Сбросить'
						onClick   = {() => this.clearAlpha()}
					>⌧</li>
				{alpha.map((ch, key) => (
					<li
						key       = {key}
						onClick   = {() => this.clickAlpha(key)}
						className = {ch.use ? 'alpha-use' : ''}
					>
						{ch.ch}
					</li>
				))}</ul>
			);
		}
	}

	renderHead() {
		const cols     = this.props.view.col;
		const td_style = this.getCellStyle();
		return (
			<thead>
				<tr style={this.getRowStyle()}>
				{cols.map((col, key) => (col['col_show'] === 'true' &&
					<th key={key} style={td_style}>{col['col_title']}</th>
				))}
				</tr>
			</thead>
		);
	}

	// Убираем из uri символы, недопустимые для якоря.
	uri2anchor(uri) {
		if (uri instanceof Object) {
			uri = Object.keys(uri).join(this.groupCols[this.uriColIndex].separator);
		} else {
			uri = String(uri);
		}
		return encodeURIComponent(uri);
	}

	createMarkup(column, value) {
		if (column.hasOwnProperty('col_html') && column.col_html === 'true') {
			return (<div dangerouslySetInnerHTML={{__html: value}}/>);
		} else {
			return value;
		}
	}

	// Выводим значение или ссылку.
	renderValue(row, icol) {
		const col = this.props.view.col[icol];
		let val = row[icol];
		if (val instanceof Object) {
			val = Object.keys(val);
		} else {
			val = [val];
		}
		if (col.hasOwnProperty('link_col') && col.link_col !== 'нет') {
			let links = row[this.colsField[col.link_col]];
			if (links instanceof Object) {
				links = Object.keys(links);
			} else {
				links = [links];
			}
			let renderLinks = [];
			for (let i = 0; i < links.length; i++) {
				const link = links[i];
				if (link !== null && typeof link === 'string' && link.length > 0) {
					const link_sep = (links.length && i < links.length - 1) ? <span>{this.groupCols[icol].separator}</span> : null;
					if (link[0] === '#') {
						// Для внутренней ссылки проскроллим страницу.
						renderLinks.push(
							<div key={'link-' + i} className='link'>
								<Link
									to     = {"#" + link.substr(1)}
									scroll = {el => { el.scrollIntoView(true); window.scrollBy(0, -56) }}
								>
									{this.createMarkup(col, val[i])}
								</Link>
								{link_sep}
							</div>
						);
					} else {
						// Внешняя ссылка откроется в новом окне.
						renderLinks.push(
							<a
								key    = {'link-' + i}
								href   = {link}
								target = '_blank'>
								{this.createMarkup(col, val[i])}
								{link_sep}
							</a>
						);
					}
				}
			}
			return renderLinks;
		} else {
			return this.createMarkup(col, val.join(this.groupCols[icol].separator));
		}
	}

	// Выводим значение для отображаемой колонки.
	renderCell(style, cols, icol, td_style, row) {
		if (cols[icol]['col_show'] === 'true') {
			return (
				<td key={icol} style={{...style, ...td_style}}>
					{this.renderValue(row, icol)}
				</td>
			);
		}
	}

	renderBody() {
		const cols     = this.props.view.col;
		const data     = this.state.data;
		const tr_style = this.getRowStyle();
		const td_style = this.getCellStyle();
		return (
			<tbody>
			{data.map((row, irow) => (
					<tr
						key   = {irow}
						style = {tr_style}
						id    = {this.uri2anchor(row[this.uriColIndex])}
					>
						{this.colsStyle.map((style, icol) => this.renderCell(style, cols, icol, td_style, row))}
					</tr>
			))}
			</tbody>
		);
	}

	renderButton() {
		if (this.state.loading) {
			return (<button 
				type      = 'button'
				className = 'btn btn-primary'
				disabled >
				<span className='spinner-border spinner-border-sm'/>
				Загрузка
			</button>);
		}
		if (this.state.hasnext) {
			return (<button 
				type      = 'button'
				className = 'btn btn-primary'
				onClick   = {(e) => this.showNext(e)} >
				Показать еще	
			</button>);
		}
	}

	onChange(event, name) {
		event.preventDefault();
		const target = event.target;
		this.state.cmp_graph[name] = target.value;
		this.loadData(true);
	}

	renderGraphSelectors() {
		if (this.props.view.type === 'cmp') {
			return (
				<div>
					<label>Граф для %CMP_FROM%</label>
					{this.renderGraphSelector('left')}
					<label>Граф для %CMP_TO%</label>
					{this.renderGraphSelector('right')}
				</div>
			);
		}
	}

	renderOption(value, num) {
		const id = value;
		return (<option key={id + '-' + num} value={id}>{value}</option>);
	}

	renderGraphSelector(name) {
		const list = this.props.view.graph_list;
		const value = this.state.cmp_graph[name];
		return (<div>
				<select
					name={name}
					value={value}
					onChange={(e) => this.onChange(e, name)}
					className='form-control'
					size='5'
				>
					{list.map((v, i) => (this.renderOption(v, i)))}
				</select>
			</div>
		);
	}

	render() {
		return(
			<div>
				{this.renderDebugInfo()}
				{this.renderGraphSelectors()}
				{this.renderAlpha()}
				<table className='show' style={this.getTableStyle()}>
					{this.renderHead()}
					{this.renderBody()}
				</table>
				<div className='button-next'>
					{this.renderButton()}
				</div>
			</div>
		);
	}

}

export default ViewTable;
